class CreditCardItemPaymentController {
    constructor($q, settings, digitalPayPaymentDistributionService) {
        this.$q = $q;
        this.settings = settings;
        this.digitalPayPaymentDistributionService = digitalPayPaymentDistributionService;
        if (!this.onError) {
            this.onError = () => {};
        }
    }

    $onInit() {
        this.hasLoadFailure = false;
        if (this.isSelected) {
            this.addPrePaymentAction();
            this.digitalPayPaymentDistributionService.addPaymentInFull(this.card.PaymentInstrumentId);
        }
    }

    setHasLoadFailure() {
        this.hasLoadFailure = true;
    }

    /**
     * Implies that the user no longer wants to make a payment using this particular credit card, remove all related hooks
     */
    $onDestroy() {
        if (!this.prePaymentActionDefinitions) {
            return;
        }
        this.prePaymentActionDefinitions.removeAction(this.card.PaymentInstrumentId);
    }

    showCvvIframe() {
        return !this.isManageMode && this.isSelected && this.card.RequiresCvv && !this.card.stepUpToken && !this.card.Expired && this.card.Allowed && !this.hasLoadFailure;
    }

    getPayingAmount(paymentInstrumentId = this.card.PaymentInstrumentId) {
        return this.digitalPayPaymentDistributionService.getPayment(paymentInstrumentId);
    }

    selectCard() {
        this.addPrePaymentAction();
        this.digitalPayPaymentDistributionService.addPaymentInFull(this.card.PaymentInstrumentId);
        this.onSelect();
        this.removeCvvError();
    }

    addPrePaymentAction() {
        if (!this.prePaymentActionDefinitions) {
            return;
        }
        this.prePaymentActionDefinitions.addAction(this.card.PaymentInstrumentId, () => this.$q.when({
            paymentInstrumentId: this.card.PaymentInstrumentId,
            amount: this.getPayingAmount(this.card.PaymentInstrumentId),
            stepUpToken: this.card.stepUpToken,
        }));
    }

    setCvvError() {
        this.cvvErrorMessage = this.settings.digitalPayError.creditCardInvalidCvvMessage;
    }

    removeCvvError() {
        this.cvvErrorMessage = '';
        this.hasLoadFailure = false;
    }

    $onChanges(changes) {
        if (changes.card && !changes.card.isFirstChange()) {
            // If a stepup token was added, add it in the prepayment action
            this.addPrePaymentAction();
        }
    }
}

CreditCardItemPaymentController.$inject = ['$q', 'Settings', 'DigitalPayPaymentDistributionService'];

const creditCardItemPaymentComponentDefinition = {
    controller: CreditCardItemPaymentController,
    template: require('./credit-card-item-payment.component.html').trim(),
    bindings: {
        card: '<',
        cardInEditMode: '<',
        prePaymentActionDefinitions: '<',
        paymentStateDefinitions: '<',
        paymentErrorStates: '<',
        refreshCreditCards: '&',
        isManageMode: '<',
        isSelected: '<',
        isSelectEnabled: '<',
        onIframeExpire: '&',
        onRemove: '&?',
        onSelect: '&?',
        onUpdate: '&?',
        onEdit: '&?',
        onError: '&?',
        shouldShowPayingAmount: '<',
    },
};

module.exports = {
    CreditCardItemPaymentController,
    creditCardItemPaymentComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/digitalpay/creditcard/credit-card-item-payment.component.js